import React from "react";
import { Accordion, Badge, Container, Title } from "@mantine/core";

export interface RoleItem {
  id: string;
  name: string;
}

interface RoleSectionProps {
  roles?: RoleItem[];
}

const RoleSection: React.FC<RoleSectionProps> = ({ roles }) => {
  return (
    <Container size="md" pt={50}>
      <Accordion
        chevronPosition="left"
        styles={{
          item: {
            // styles added to all items
            borderRadius: "15px",
            backgroundColor: "#f1f2f4",
            border: `none`,

            // styles added to expanded item
            "&[data-active]": {
              backgroundColor: "#f1f2f4",
            },
            "&:hover": {
              backgroundColor: "#f1f2f4",
            },
          },
          control: {
            borderRadius: "15px",
            "&:hover": {
              backgroundColor: "#f1f2f4",
            },
            svg: {
              width: "2rem",
            },
          },
        }}
      >
        <Accordion.Item value="roles">
          <Accordion.Control>
            <Title size="h1" fw={300} color={"#3e4066"}>
              Roles
            </Title>
          </Accordion.Control>
          <Accordion.Panel>
            {roles?.map((item) => (
              <Badge
                key={item.id}
                size="xl"
                variant="filled"
                mr={10}
                mb={10}
                pt={20}
                pb={20}
                sx={{
                  color: "#3e4066",
                  textTransform: "capitalize",
                  backgroundColor: "#ADFCA2",
                  fontWeight: 500,
                  minWidth: "100px",
                }}
              >
                {item.name}
              </Badge>
            ))}
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Container>
  );
};

export default RoleSection;
